import { Flex } from 'components';
import { IGenericModal, Modal } from 'components/Modal/Modal';
import { TextareaField } from 'components/_form';

import { useTranslation } from 'react-i18next';

interface Props extends IGenericModal {}

export const SendNotificationsModal = ({ isOpen, onCancelClick }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onCancelClick={onCancelClick}
      headerTitle={t('tasks.sendNotificationsToSelectedOnes')}
      mainButton={{
        action: () => {},
        variant: 'eucalyptus',
        label: t('buttons.sendMessage')
      }}
      isSecondButtonVisible
    >
      <Flex flexDirection="column">
        <TextareaField label="common.message" />
      </Flex>
    </Modal>
  );
};
